export function isNullOrWhitespace(value?: string): boolean {
  return !isNotNullOrWhitespace(value);
}

export function isNotNullOrWhitespace(value?: string): boolean {
  return /\S/.test(value ?? "");
}